import React,{useState,useEffect} from "react";
import './classes/CreateProductCategory.css';
import { configData } from "../config";
import Loading from './Loading';
import { Helmet } from 'react-helmet';
import { Link, useNavigate,useLocation,useParams  } from 'react-router-dom';
import SalespersonSidebar from "./SalespersonSidebar";



const CreateProductCategory = () => {
    
    const [isLoading, setIsLoading] = useState(true);    
    const location  = useLocation();
    const drupal_uid = localStorage.getItem('drupal_uid');
    const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
    var loggedin_domain = drupal_domain_url;
    if(localStorage.getItem('loggedin_domain')) {
    loggedin_domain = localStorage.getItem('loggedin_domain');
    } 
    var {uid} = useParams();
    var {username} = useParams();
    if(location.state) {
    uid = location.state;
    }
    const {tab} = useParams();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;
    useEffect(() => {
        Promise.all([
          retrieveparentcategory()
         ])
         .then(() => {
         
          setIsLoading(false);
        })
    }, []);
     async function retrieveparentcategory() {
        
           
                const response = await fetch(
                     app_url+'smwwcommerceproduct/getapparelcategorylist',
                    {
                        method: "GET",
      
                        headers: {
                        'Content-Type': 'application/json',
                        },
                    }
                )           
                const responsedata = await response.json();
                if(responsedata.data.msg === "Success") {
                    setParent(responsedata.data.result);
                }
           
        }
        const initialForm = {
        parent:'0',
        category_name:'',
        status:'1'
        };

     
      const [formData, setFormData] = useState(initialForm);     
      const [errors, setErrors] = useState([]);          
      const[success,setSuccess] = useState('');
     const [parent, setParent] = useState({});
     
      



const validateForm = () => {

  const newMessages = [];



  if (!formData.category_name) {
    newMessages.push("Category Name is required.");
  }


  setErrors(newMessages);         
  return newMessages.length === 0;
     
};

 
 
 
const handleChange = (e) => {
  const { name, value } = e.target;

 

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
  
 
};



 const handleSubmit = async (e) => {
  e.preventDefault();   

  

     if(validateForm()) {
     const response = await fetch(app_url+'smwwcommerceproduct/addproductcategory', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
      if(data.data.msg === "success") {
        navigate('/admin/smww-commerce/product-categories-list', { state: { message: data.data.result } });
      }
    } else {
      window.scrollTo(0, 0);
    }
    
  
   console.log("create Product Category submitted formdata",formData);
};
    return(
          <>
                    {isLoading ? (
                        <Loading />
                    ) : (
                <div id="main">
                     <Helmet>
                        <title>
                            Create Product Category
                        </title>
                    </Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="create-category-container">
                        {errors.length > 0 && (
                          <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 8px no-repeat`}}>
                          {errors.map((item, index) => {
                          return <>{item}<br /></>
                          
                        })}  
                          </div>
                        )}
                        {success && (
                          <div className="set-message-done">
                            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span><span dangerouslySetInnerHTML={{__html: success}}></span>
                          </div>
                          
                      
                        )}
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <label>Parent</label>
                                    <select
                                        name="parent"
                                        onChange={handleChange}
                                        value={formData.parent}
                                    >
                                        <option value="0">-Select-</option>
                                     {parent.map((product) => (
                                        <option key={product.value} value={product.value}>
                                            {product.label}
                                        </option>
                                        ))}
                                    </select>
                                    </div> 
                                    <div>
                                        <label>Category Name<span className="form-required">*</span></label>
                                        <input type="text" name="category_name" id="category_name" value={formData.category_name} onChange={handleChange}/>
                                    </div>
                <div>
        
                <label>
                    Status  <span className="form-required">*</span>
                </label>
                <select
                    id="status"
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                >
                    <option value="1">Active</option>
                    <option value="2">Disabled</option>                          
                </select>
            </div>           
                        
            <input type="submit" value="Save Product Category"  className="form-submit form-action"  />
            </form>
        </div>

    </div>
    <div className="right">
        <SalespersonSidebar/>
    </div>
    </div>
    )}
    </>
    );
};

export default CreateProductCategory;

